<template>
    <div class="calendar">

    <div class="calendar__weekday-title u-t-h6">
        <span class="calendar__weekday-title__word">Sunday</span>
        <span class="calendar__weekday-title__letter">S</span>
    </div>

    <div class="calendar__weekday-title u-t-h6">
        <span class="calendar__weekday-title__word">Monday</span>
        <span class="calendar__weekday-title__letter">M</span>
    </div>

    <div class="calendar__weekday-title u-t-h6">
        <span class="calendar__weekday-title__word">Tuesday</span>
        <span class="calendar__weekday-title__letter">T</span>
    </div>

    <div class="calendar__weekday-title u-t-h6">
        <span class="calendar__weekday-title__word">Wednesday</span>
        <span class="calendar__weekday-title__letter">W</span>
    </div>

    <div class="calendar__weekday-title u-t-h6">
        <span class="calendar__weekday-title__word">Thursday</span>
        <span class="calendar__weekday-title__letter">T</span>
    </div>

    <div class="calendar__weekday-title u-t-h6">
        <span class="calendar__weekday-title__word">Friday</span>
        <span class="calendar__weekday-title__letter">F</span>
    </div>

    <div class="calendar__weekday-title u-t-h6">
        <span class="calendar__weekday-title__word">Saturday</span>
        <span class="calendar__weekday-title__letter">S</span>
    </div>



    <CalendarDay :disabled="true" v-for="index in paddingDays"/>
    <CalendarDay v-for="(item, index) in allData" :date="item.date" v-bind:key="index" 
        :soldout="item.availability !== 'available'"  
        @selected="selectDay" 
        v-bind:selected="item.selected" 
        :disabled="false"
        :price="item.price"
        :item="item"
        :priceHigh="item.priceHigh"
        :priceLow="item.priceLow" 
    />
   


</div>
</template>

<script>
import CalendarDay from './CalendarDay';
import Vue from 'vue';
export default {
    name: 'Calendar',
    components: {
        CalendarDay
    },
    props: ['availability'],
    computed: {
        paddingDays () {
            if(this.availability instanceof Array) {
                if(this.availability.length > 0 && this.availability[0].date) {
                    return parseInt(this.availability[0].date.format('d'));
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
        }
    },
    data() {
        return {
            allData: [],
            firstRender: true
        }
    },
    mounted() {
        if(this.firstRender) {
            for(let i = 0; i < this.availability.length; i++) {
                this.allData[i] = Object.assign({        
                    "selected": false // add additional fields to the day here (sold out, etc)
                }, this.availability[i]);
            }
            this.firstRender = false;
        }
    },
    methods: {
        selectDay(day) {
            this.$emit('selected', day);
            for(let i in this.allData) {
                if(this.allData[i].date === day) {
                    Vue.set(this.allData[i], 'selected', true);
                } else {
                    Vue.set(this.allData[i], 'selected', false);
                }     
            }
        }
    },
    watch: {
        availability: function(newA, oldA) {
            let tmp = []
            for(let i = 0; i < this.availability.length; i++) {
                let o = Object.assign({}, this.availability[i]);
                o.selected = false
                tmp.push(o);
            }
            this.allData = tmp;
        }
    }
}
</script>

<style>

</style>
